import { render, staticRenderFns } from "./SelectedFacet.vue?vue&type=template&id=0bbbf71f&scoped=true"
import script from "./SelectedFacet.vue?vue&type=script&lang=ts"
export * from "./SelectedFacet.vue?vue&type=script&lang=ts"
import style0 from "./SelectedFacet.vue?vue&type=style&index=0&id=0bbbf71f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbf71f",
  null
  
)

export default component.exports